(this.Shopify = this.Shopify || {}),
    (this.LUC = this.LUC || {}),
    (this.LUC.addresses = (function (t) {
        "use strict";
        function e(t) {
            if ("string" != typeof t) throw new TypeError(t + " is not a string.");
            this.countryOptions = t;
        }
        function h(t, e) {
            return t.querySelector('option[value="' + e + '"]');
        }
        function u(t, e, n) {
            var o,
                r,
                i,
                a = h(t, n),
                u = JSON.parse(a.getAttribute("data-provinces"));
            return (
                (e.options.length = 0),
                u.length &&
                    ((r = u),
                    (i = (o = e).getAttribute("data-default")),
                    r.forEach(function (t) {
                        var e = document.createElement("option");
                        (e.value = t[0]), (e.textContent = t[1]), o.appendChild(e);
                    }),
                    i && h(o, i) && (o.value = i)),
                u
            );
        }
        return (
            (e.prototype.build = function (r, i, a) {
                if ("object" != typeof r) throw new TypeError(r + " is not a object.");
                if ("object" != typeof i) throw new TypeError(i + " is not a object.");
                var t = r.getAttribute("data-default");
                if (((a = a || {}), (r.innerHTML = this.countryOptions), (r.value = t) && h(r, t))) {
                    var e = u(r, i, t);
                    a.onCountryChange && a.onCountryChange(e, i, r);
                }
                r.addEventListener("change", function (t) {
                    var e = t.target,
                        n = e.value,
                        o = u(e, i, n);
                    a.onCountryChange && a.onCountryChange(o, i, r);
                }),
                    a.onProvinceChange && i.addEventListener("change", a.onProvinceChange);
            }),
            (t.CountryProvinceSelector = e),
            t
        );
    })({}));
